var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaidOutWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 20 20",
    height: "20px",
    viewBox: "0 0 20 20",
    width: "20px",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 20,
    width: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17,5.5v6h-1.5V6.26l-4-2.91l-4,2.91V7.5H6v-2l5.5-4L17,5.5z M18,16v0.5l-6.5,2L6,16.82V18H1V9h6l5.59,2 c0.85,0.3,1.41,1.1,1.41,2h1C16.66,13,18,14.34,18,16z M4.5,10.5h-2v6h2v-0.14V10.5z M16.39,15.43c-0.23-0.54-0.76-0.93-1.39-0.93 H9.74l-2-0.8l0.53-1.4l1.87,0.7h2.36c0-0.26-0.17-0.5-0.42-0.59L6.74,10.5H6v4.75l5.5,1.68L16.39,15.43z M12.62,6h-0.75v0.75h0.75V6 z M11.12,6h-0.75v0.75h0.75V6z M12.62,7.5h-0.75v0.75h0.75V7.5z M11.12,7.5h-0.75v0.75h0.75V7.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidOutWhite);
export default __webpack_public_path__ + "static/media/paid_out_white.63d95e94462e63feac5f31f037666e61.svg";
export { ForwardRef as ReactComponent };